import MultipleOptionsInput from "./MultipleOptionsInput";

export default MultipleOptionsInput;
